<template>
  <button
    class="no-tap-highlight group flex cursor-pointer items-center gap-1 bg-transparent"
    :class="[isMenuVisible && $style.isVisible]"
    :title="isMenuVisible ? 'Show menu' : 'Hide menu'"
    type="button"
    @click="menuToggle"
  >
    <span
      class="flex h-10 w-10 items-center duration-300 [transition-property:transform,padding]"
      :class="isMenuVisible && 'pb-1.5'"
    >
      <span>
        <span
          v-for="idx in 2"
          :key="idx"
          :class="[
            $style.line,
            !isMenuVisible && idx === 1 && '!mr-1',
            isMenuVisible
              ? 'bg-yellow'
              : mixBlendActive
                ? 'bg-yellow'
                : store.theme === 'light'
                  ? 'bg-yellow'
                  : 'bg-black'
          ]"
        ></span>
      </span>
    </span>
    <span class="uppercase">
      {{ isMenuVisible ? 'Close' : 'Menu' }}
    </span>
  </button>
</template>

<script setup lang="ts">
const mixBlendActive = useState('mixBlend')
const store = useAppStore()
const { menuToggle } = useMenu()
const isMenuVisible = useState('menu')
</script>

<style lang="postcss" module>
.line {
  --line-thickness: 2px;
  --line-width: 32px;
  --line-margin: 4px;
  --line-radius: 0px;

  @apply my-[var(--line-margin)] block h-[var(--line-thickness)] w-[var(--line-width)] origin-center transform-gpu rounded-[var(--line-radius)] duration-300 ease-quart-in-out [transition-property:transform,padding];
}

.isVisible {
  .line {
    &:nth-child(1) {
      @apply translate-y-1.5 rotate-[20deg];
    }

    &:nth-child(2) {
      @apply -translate-y-0 -rotate-[20deg];
    }
  }
}
</style>
